/* eslint-disable no-console -- simple logger */
import { APPLICATION_NAME } from '~/constants/app';

export enum LogLevel {
  None,
  Error,
  Warning,
  Info,
  Debug,
}

export type LogMethod = (...args: unknown[]) => void;
export type LogMethodsMap = Map<LogLevel, LogMethod>;

export const DEFAULT_LOG_LEVEL = LogLevel.Warning;

export const logMethodsMap: LogMethodsMap = new Map([
  [LogLevel.None, (...args: unknown[]) => {}],
  [LogLevel.Error, console.error],
  [LogLevel.Warning, console.warn],
  [LogLevel.Info, console.info],
  [LogLevel.Debug, console.log],
]);

const getTime = () => {
  const date = new Date();
  const minutes = `0${date.getMinutes()}`;
  const seconds = `0${date.getSeconds()}`;
  const milliseconds = `00${date.getMilliseconds()}`;
  const LAST_TWO_DIGITS = -2;
  const LAST_THREE_DIGITS = -3;

  return `${date.getHours()}:${minutes.slice(LAST_TWO_DIGITS)}:${seconds.slice(
    LAST_TWO_DIGITS,
  )}.${milliseconds.slice(LAST_THREE_DIGITS)}`;
};

export const getLogLevel = () => {
  let result =
    Boolean(window.localStorage) &&
    Number(
      JSON.parse(localStorage.getItem(`${APPLICATION_NAME} debug`) ?? String(DEFAULT_LOG_LEVEL)),
    );
  if (typeof result !== 'number' || result < LogLevel.None || result > LogLevel.Debug) {
    result = DEFAULT_LOG_LEVEL;
  }

  return result;
};

export const log = (level: LogLevel, ...args: unknown[]) => {
  const currentLevel = getLogLevel();
  if (currentLevel < level) {
    return;
  }
  const time = getTime();
  const method = logMethodsMap.get(level);
  method?.(`%c${time} %c${APPLICATION_NAME}:`, 'color: #09c', 'color: #c90;', ...args);
};

export const logError = (...args: unknown[]) => log(LogLevel.Error, ...args);
export const logWarning = (...args: unknown[]) => log(LogLevel.Warning, ...args);
export const logInfo = (...args: unknown[]) => log(LogLevel.Info, ...args);
export const logDebug = (...args: unknown[]) => log(LogLevel.Debug, ...args);
